require('cross-fetch/polyfill');
let processedEntities = {};
const interfaceMap = new Map();
const ENTITY_CHECK_CACHE_TIME = 30 * 60 * 1000;
let lastFetchTime = 0;
function getTypeCacheSettingsHelper({
  uri = process.env.BLAZE_GRAPHQL_URI,
  loadEntitiesInBrowser = true
}) {
  async function loadEntities() {
    if (!shouldLoadEntities()) return;
    const headers = {
      'Content-Type': 'application/json'
    };
    if (process.env.BLAZE_CLIENT_HEADER) {
      headers['X-Blaze-Client'] = process.env.BLAZE_CLIENT_HEADER;
    }
    const result = await fetch(uri, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        variables: {},
        query: '{entities: getEntitySchemas {id, interfaces, actions}}'
      })
    });
    const json = await result.json();
    const {
      data: {
        entities
      }
    } = json;

    // this import should only happen on the server so will not be in client bundle
    const {
      prepareName,
      prepareInterfaceName
    } = await import('@blaze-cms/core-graphql-schema-builder/src/utils/conversion/prepare-name');
    processedEntities = {};
    entities.forEach(({
      id,
      interfaces,
      actions: {
        get
      }
    }) => {
      const graphqlType = prepareName(id);
      const graphqlInterfaces = interfaces.map(interfaceItem => {
        if (!interfaceMap.has(interfaceItem)) interfaceMap.set(interfaceItem, prepareInterfaceName(interfaceItem));
        return interfaceMap.get(interfaceItem);
      });
      processedEntities[graphqlType] = {
        interfaces: graphqlInterfaces,
        getQuery: get
      };
    });
    lastFetchTime = Date.now();
  }
  function shouldLoadEntities() {
    if (process.browser && !loadEntitiesInBrowser) return false;
    return Date.now() > lastFetchTime + ENTITY_CHECK_CACHE_TIME;
  }
  function getTypeCacheSettings(entitiesConfig = processedEntities) {
    processedEntities = entitiesConfig;
    const typePolicyQueryFields = {};
    const possibleTypes = {};
    Object.entries(entitiesConfig).forEach(([graphqlType, {
      interfaces,
      getQuery
    }]) => {
      typePolicyQueryFields[getQuery] = {
        read(_, {
          args,
          toReference
        }) {
          return toReference({
            __typename: graphqlType,
            id: args.id
          });
        }
      };
      interfaces.forEach(interfaceItem => {
        if (!possibleTypes[interfaceItem]) possibleTypes[interfaceItem] = [];
        possibleTypes[interfaceItem].push(graphqlType);
      });
    });
    return {
      typePolicyQueryFields,
      possibleTypes
    };
  }
  function getProcessedEntities() {
    return processedEntities;
  }
  return {
    loadEntities,
    getTypeCacheSettings,
    getProcessedEntities
  };
}
export default getTypeCacheSettingsHelper;
//# sourceMappingURL=get-type-cache-settings-helper.js.map